import styled from "styled-components"

export default styled.h1`
  color: #343434;
  font-size: 22px;
  font-weight: 500;
  margin-bottom: 15px;
  padding: 0px 10px;
`
